// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep :focus {
  outline: 0 !important;
  box-shadow: none !important;
}
::ng-deep div.content-layout {
  display: flex;
  position: relative;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  flex: 1;
}
::ng-deep div.background {
  position: relative;
  width: 100%;
  min-height: 475px !important;
}
::ng-deep div.background:before {
  content: "";
  position: absolute;
  background-image: url("/assets/images/rooftop-solar-grid.jpeg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  width: 100%;
  height: 100%;
  min-height: 475px;
  z-index: 1;
}
::ng-deep ul.disc {
  list-style-type: disc;
  margin-bottom: 1rem;
}
::ng-deep ul.disc li {
  margin-left: 2rem;
  margin-bottom: 0.5rem;
}
::ng-deep .article-main-content .meta-details {
  display: inline-block;
  padding: 6px 15px 6px 7px;
  border-radius: 30px;
  background-color: var(--primary);
  position: absolute;
  right: 1.5rem;
  bottom: 2rem;
}
::ng-deep .article-main-content .meta-details.bottom-right-no-pad {
  right: 0;
  bottom: 0;
}
::ng-deep .article-main-content .meta-details img {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  display: inline-block;
}
::ng-deep .article-main-content .meta-details span {
  color: var(--white);
  display: inline-block;
  margin-left: 10px;
  font-size: 10px !important;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/news/trending/trending.component.scss"],"names":[],"mappings":"AACI;EACI,qBAAA;EACA,2BAAA;AAAR;AAGI;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,OAAA;AADR;AAII;EACI,kBAAA;EACA,WAAA;EACA,4BAAA;AAFR;AAIQ;EACI,WAAA;EACA,kBAAA;EACA,+DAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AAFZ;AAMI;EACI,qBAAA;EACA,mBAAA;AAJR;AAMQ;EACI,iBAAA;EACA,qBAAA;AAJZ;AASQ;EACI,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAPZ;AASY;EACI,QAAA;EACA,SAAA;AAPhB;AAUY;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AARhB;AAWY;EACI,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AAThB","sourcesContent":["::ng-deep {\n    :focus {\n        outline: 0 !important;\n        box-shadow: none !important;\n    }\n\n    div.content-layout {\n        display: flex;\n        position: relative;\n        justify-content: center;\n        flex-wrap: wrap;\n        flex-direction: row;\n        flex: 1;\n    }\n\n    div.background {\n        position: relative;\n        width: 100%;\n        min-height: 475px !important;\n\n        &:before {\n            content: \"\";\n            position: absolute;\n            background-image: url('/assets/images/rooftop-solar-grid.jpeg');\n            background-size: contain;\n            background-repeat: no-repeat;\n            background-position: left top;\n            width: 100%;\n            height: 100%;\n            min-height: 475px;\n            z-index: 1;\n        }\n    }\n\n    ul.disc {\n        list-style-type: disc;\n        margin-bottom: 1rem;\n\n        li {\n            margin-left: 2rem;\n            margin-bottom: .5rem;\n        }\n    }\n\n    .article-main-content {\n        .meta-details {\n            display: inline-block;\n            padding: 6px 15px 6px 7px;\n            border-radius: 30px;\n            background-color: var(--primary);\n            position: absolute;\n            right: 1.5rem;\n            bottom: 2rem;\n\n            &.bottom-right-no-pad {\n                right: 0;\n                bottom: 0;\n            }\n\n            img {\n                height: 28px;\n                width: 28px;\n                border-radius: 50%;\n                display: inline-block;\n            }\n\n            span {\n                color: var(--white);\n                display: inline-block;\n                margin-left: 10px;\n                font-size: 10px !important;\n                font-weight: 500;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
